module.exports = __webpack_public_path__ + "img/up-left-arrow.8f42a435.png";